$(document).ready(function(){

    function showLoader(loader = null) {
      // $('#body-loader').show();
      if(loader != null) {
        loader.show();
      }
    }
    function hideLoader() {
      $('.loader_question').hide();
    } 


    // function disableQuantityButtons() {
    //     $('[eq-cart__item]').each(function () {
    //         var $input = $(this).find('input.quantity__input');
    //         var quantity = parseInt($input.val());
    //         var min = parseInt($input.attr('data-min')) || 1;
    //         var max = parseInt($input.attr('max')) || 9999;

    //         $(this).find('[name="minus"]').prop('disabled', quantity <= min);
    //         $(this).find('[name="plus"]').prop('disabled', quantity >= max);
    //     });
    // }

    function updateCartView(vat_call = true) {
      // showLoader();
        $.get(routes.cart_url, function (data) {
            var html = $(data).find('[data-cart-content]').html();

            if($(data).find('[data-cart-content]').find('.is-empty').length > 0) {
                  $('[data-cart-content]').html(html);
                  
                  var detailSLider = $('body').find('.js-tab-detail-slider')[0];

                  if ($('body').find('.js-tab-detail-slider').length > 0){
                  if(!$(detailSLider).hasClass('slick-initialized')) {
                              $(detailSLider).slick({
                                  slidesToShow: parseFloat($(detailSLider).attr('data-slide-desktop'), 10),
                                  slidesToScroll: 1,
                                  dots: false,
                                  arrows: true,
                                  autoplay: false,
                                  speed: 1000,
                                  infinite: false,
                                  loop: false,
                                  draggable: false,
                                  swipe: false,
                                  touchMove: false,
                                  prevArrow: '<button type="button" class="slick-arrow slick-prev-arrow slick-prev"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7.09619C17.5523 7.09619 18 7.54391 18 8.09619C18 8.64848 17.5523 9.09619 17 9.09619V7.09619ZM0.292892 8.8033C-0.0976315 8.41277 -0.0976315 7.77961 0.292892 7.38908L6.65685 1.02512C7.04738 0.634599 7.68054 0.634599 8.07107 1.02512C8.46159 1.41565 8.46159 2.04881 8.07107 2.43934L2.41421 8.09619L8.07107 13.753C8.46159 14.1436 8.46159 14.7767 8.07107 15.1673C7.68054 15.5578 7.04738 15.5578 6.65685 15.1673L0.292892 8.8033ZM17 8.09619V9.09619H1V8.09619V7.09619H17V8.09619Z" fill="#222222"></path></svg></button>',
                                  nextArrow: '<button type="button" class="slick-arrow slick-next-arrow slick-next"><svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 7.09619C0.447715 7.09619 0 7.54391 0 8.09619C0 8.64848 0.447715 9.09619 1 9.09619V7.09619ZM17.7071 8.8033C18.0976 8.41277 18.0976 7.77961 17.7071 7.38908L11.3431 1.02512C10.9526 0.634599 10.3195 0.634599 9.92893 1.02512C9.53841 1.41565 9.53841 2.04881 9.92893 2.43934L15.5858 8.09619L9.92893 13.753C9.53841 14.1436 9.53841 14.7767 9.92893 15.1673C10.3195 15.5578 10.9526 15.5578 11.3431 15.1673L17.7071 8.8033ZM1 8.09619V9.09619H17V8.09619V7.09619H1V8.09619Z" fill="#222222"></path></svg></button>',
                                  responsive: [
                                      {
                                          breakpoint: 992,
                                          settings: {
                                              slidesToShow: parseFloat($(detailSLider).attr('data-slide-tab'), 10),
                                          }
                                      },
                                      {
                                          breakpoint: 768,
                                          settings: {
                                              slidesToShow: parseFloat($(detailSLider).attr('data-slide-mobile'), 10),
                                          }
                                      }
                                  ]
                              });
                      } else {
                        $(detailSLider).slick("refresh");
                      }
                  }
                  $(".js-product-media").each(function(){
                    if($(this).hasClass('slick-initialized')){
                    $(this).slick("refresh");
                    }
                  });
            
            }

            if($('[data-cart-content]').length > 0) {
              $('[data-cart-content] [data-js_chnage_items]').html($(data).find('[data-cart-content] [data-js_chnage_items]').html());
              $('[data-cart-content] [data-js_chnage_summary]').html($(data).find('[data-cart-content] [data-js_chnage_summary]').html());
            }
            if($('.header__cart').length > 0) {
              $('.header__cart').html($(data).find('.header__cart').html());
            }

            $(data).find('[js_change_only_price]').each(function () {
                const targetKey = $(this).attr('data-js_change_only_price_target');
                const newHtml = $(this).html();

                if (targetKey) {
                  const $existingTarget = $('[data-js_change_only_price_target="' + targetKey + '"]');
                  if ($existingTarget.length > 0) {
                    $existingTarget.html(newHtml);
                  }
                }
            });

        
            toggleCheckout();

        }).always(() => {

          setTimeout(function() {
            if (vat_call == true) {
              const el = document.querySelector('[data-vat-related]:checked');
              if (el) {
                el.dispatchEvent(new Event('change', { bubbles: true }));
              }
            } else {
              hideLoader();
            }
          },1000);

        });
 
    }

    

$('body').on('click', '[data-apply_discount]', function (e) {
  e.preventDefault();

  const newCode = $.trim($('input[name="discount"]').val()).toUpperCase();
  if (!newCode) return;

  showLoader();

  $.getJSON('/cart.js')
    .done(function (cart) {
      const current = (cart.discount_codes || []).map(d => d.code.toUpperCase());

      const combined = Array.from(new Set([...current, newCode])).join(',');

      $.ajax({
        type:        'POST',
        url:         '/cart/update.js',
        data:        JSON.stringify({ discount: combined }),
        dataType:    'json',
        contentType: 'application/json',
        complete:    function () { updateCartView(); }
      });
    })
    .fail(hideLoader);
});

function removeDiscount(code) {
  $.getJSON('/cart.js').done(function (cart) {
    const remain = (cart.discount_codes || [])
      .map(d => d.code.toUpperCase())
      .filter(c => c !== code.toUpperCase())
      .join(',');

    $.post('/cart/update.js', { discount: remain }, updateCartView, 'json');
  });
}


    $('body').on('click', '[eq-cart__item-remove]', function (e) {
      e.preventDefault();

      var $clickedItem = $(this).closest('[data-key]');
      var key = $clickedItem.data('key');
      var oneTimeStarp = $(this).closest('[data-one-time-strap]').data('one-time-strap');
      
      showLoader();

      if (oneTimeStarp === 'yes') {
        var itemsToRemove = {};
        $('[data-one-time-strap="yes"]').each(function () {
          var itemKey = $(this).data('key');
          if (itemKey) {
            itemsToRemove[itemKey] = 0; // set quantity 0 to remove
          }
        });

        // Use /cart/update.js to remove multiple items at once
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: itemsToRemove }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            updateCartView();
          },
          error: function () {
            hideLoader();
          }
        }).done(function () {
          syncAlarm();
        });

      } else {
        // Remove single item using /cart/change.js
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: JSON.stringify({ id: key, quantity: 0 }),
          dataType: 'json',
          contentType: 'application/json',
          success: function () {
            updateCartView();
          },
          error: function () {
            hideLoader();
          }
        }).done(function () {
          syncAlarm();
        });
      }
    });

    $('body').on('click', '[eq-cart__item-edit]', function (e) {
      e.preventDefault();
      var target_url =  $(this).attr("href");
      var $clickedItem = $(this).closest('[data-key]');
      var key = $clickedItem.data('key');
      var oneTimeStarp = $(this).closest('[data-one-time-strap]').data('one-time-strap');
      showLoader();
      if (oneTimeStarp == 'yes') 
      {
        var itemsToRemove = {};
        $('[data-one-time-strap="yes"]').each(function () {
          var itemKey = $(this).data('key');
          if (itemKey) {
            itemsToRemove[itemKey] = 0; // set quantity 0 to remove
          }
        });

        // Use /cart/update.js to remove multiple items at once
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: JSON.stringify({ updates: itemsToRemove }),
          dataType: 'json',
          contentType: 'application/json',
          async: false,
          success: function () {
            window.location = target_url;
          },
          error: function () {
            hideLoader(); 
          }
        });
      } 
      else 
      {
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: JSON.stringify({ id: key, quantity: 0 }),
            dataType: 'json',
            contentType: 'application/json',
            success: function () {
              window.location = target_url;
            },
            error: function () {
              hideLoader(); 
            }
        });
      }
    });

    $('body').on("input",".eq-cart__textarea", function(e){
      e.preventDefault();
      var _this = $(this);
        $.post(`/cart/update.js`, {
          attributes: { [_this.attr("data-name_attr")]: _this.val() }
        }).always(() => updateCartView());  
    });


    // $('body').on('click', '[data-add-upsell-cart]', function (e) {
    //   e.preventDefault();

    //   var $form = $(this).closest('form');
    //   var formData = $form.serialize();

    //   showLoader();

    //   $.ajax({
    //     type: 'POST',
    //     url: '/cart/add.js',
    //     data: formData,
    //     dataType: 'json',
    //     success: function (response) {
    //       updateCartView();
    //     },
    //     error: function () {
    //       hideLoader(); 
    //     }
    //   });
    // });

    function toggleCheckout() {
  let allAnswered = true;

  $('input[type="radio"][data-check]').each(function () {
    if (!$(`input[name="${this.name}"]:checked`).length) {
      allAnswered = false;
      return false; 
    }
  });

  $('[name="checkout"]').prop('disabled', !allAnswered);
}

$(document).on('change', 'input[type="radio"][data-check]', function () {

toggleCheckout();
  
  showLoader($(this).closest('.eq-cart__questions-wrap').find('.loader_question')); 

  var root   = (typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  console.log(this.hasAttribute('data-vat-related'));
  
  if (this.hasAttribute('data-vat-related')) {

  var wantExempt = this.dataset.attr.toLowerCase() == 'yes';   

  if(wantExempt) {
    $('.js_change_vat_text').html("*excluding VAT");
  } else {
    $('.js_change_vat_text').html("*including VAT");
  }

  const status = wantExempt ? 'VAT Exempt' : 'VAT Included';

    console.log(wantExempt);
    $.post(`${root}cart/update.js`, {
      attributes: { vat_status: status }
    }).always(() => updateCartView(false));


  $.getJSON(`${root}cart.js`).done(function (cart) {

    const updates = {};  

    cart.items.forEach(function (item, index) {
      const $map = $(`script[data-vat_item_pdp="${(item.key).replace(":","_")}"]`);
      if (!$map.length) {
        return;                         
      }  

      const map     = JSON.parse($map.text());
      const newVid  = wantExempt ? map.vat_exclude : map.vat_include;
      if (!newVid || newVid == item.variant_id) {
        return;                         
      }; 

      console.log(item);

      updates[item.variant_id] = 0;                      
  
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify({ line: index+1, quantity: 0 }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
        },
        error: function () {
          hideLoader(); 
        },
        async: false
    });
    console.log(newVid);
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ id: newVid, quantity: item.quantity,selling_plan:  item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : "" }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
        },
        error: function () {
          hideLoader(); 
        },
        async: false
    });


    });

    if ($.isEmptyObject(updates)) {
        hideLoader(); 
        return;                         
      };               

 
  });
    

  }

 if (this.hasAttribute('data-subscription_change')) {

  var wantExempt = this.dataset.attr.toLowerCase() == 'yes';     
  var _this = this;

  $.getJSON(`${root}cart.js`).done(function (cart) {
    cart.items.forEach(function (item, index) {
      const $map = $(`script[data-selling_plans="${(item.key).replace(":","_")}"]`);
      if (!$map.length) {
        hideLoader(); 
        return;                         
      };                         

      const map = JSON.parse($map.text());
      if(item.selling_plan_allocation) {
        console.log(map, _this.value);
      const newSellingId  = map[_this.value.toUpperCase()];
      console.log(map, _this.value, newSellingId);
      if (!newSellingId || newSellingId == item.selling_plan_allocation.selling_plan.id) {
        hideLoader(); 
        return;                         
      }; 
                  
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify({ line: index+1, quantity: 0 }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
        },
        error: function () {
          hideLoader(); 
        },
        async: false
    });

    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ id: item.id, quantity: item.quantity,selling_plan:  newSellingId }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          updateCartView();
        },
        error: function () {
          hideLoader(); 
        },
        async: false
    });

    }
    });
  });
  }

if (this.hasAttribute('data-product_attribute')) {
  var attrName = $(this).data('product_attribute_text');
  var attrVal  = this.value.trim();

   $.getJSON('/cart.js').done(({ items }) => {

    items.forEach(({ key, quantity, properties }) => {
      var newProps = { ...properties, [attrName]: attrVal };
console.log(newProps);
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        contentType: 'application/json',
        dataType: 'json',
        async: false,
        data: JSON.stringify({
          id: key,          
          quantity,               
          properties: newProps    
        })
      });
    });

  }).always(updateCartView);
}

if (this.hasAttribute('data-check_product_list')) {
    const variantId = $(this).attr('data-add_product');
    const proId = $(this).attr('data-add_product_id');       
    const wantIt = this.dataset.attr === 'yes';        
    console.log(proId);

    $.getJSON(`${root}cart.js`).done(cart => {
      const lines = cart.items.filter(i => proId?.indexOf(i.product_id) > -1);
      console.log(lines, proId, wantIt);

      if (lines.length) {
        lines.forEach(line => {
          console.log(lines);
          $.ajax({
            url: `${root}cart/change.js`,
            type: 'POST',
            data: { id: line.id, quantity: 0 },
            async: false,
            complete: updateCartView
          });
        });
      }
      if (wantIt) {
          $.ajax({
            url: `/cart/add.js`,
            type: 'POST',
            data: { id: variantId, quantity: 1 },
            async: false,
            complete: updateCartView
          });

      }

      if(!wantIt && this.hasAttribute('data-add_all_list_above')) {
        var all_variant = variantId.split(',');
        console.log(" ssssssssss ", all_variant);

         let updates = {};

          for (let v_id of all_variant) {
            if (v_id == '') continue;
            updates[v_id] = 1; 
          }

          console.log(updates, " updates");

          if (Object.keys(updates).length > 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: JSON.stringify({ updates: updates }),
              async: false,
              dataType: 'json',
              contentType: 'application/json',
              success: function () {
                updateCartView();
              },
              error: function () {
                hideLoader();
              }
            }).done(function () {
              
            });
              }
            }

      updateCartView();


    });
  }

if (this.hasAttribute('data-add_product_both')) {

  const wantIt = this.dataset.attr === 'yes';
  const yesVariantId = this.dataset.add_product;
  const noVariantId = this.dataset.add_product_both;

  const selectedVariantId = wantIt ? yesVariantId : noVariantId;
  const removeVariantId = wantIt ? noVariantId : yesVariantId;


  $.getJSON(`${root}cart.js`).done(cart => {
    const selectedLine = cart.items.find(i => i.variant_id == selectedVariantId);
    const removeLine = cart.items.find(i => i.variant_id == removeVariantId);

    console.log(selectedLine, removeLine);

    if (removeLine) {           
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: JSON.stringify({ id: removeLine.key, quantity: 0 }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
           updateCartView();
        },
        error: function () {
          hideLoader(); 
        },
        async: false
    });
  }
  
   if (!selectedLine) {
    // showLoader(); 
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
        dataType: 'json',
        contentType: 'application/json',
        success: function () {
          updateCartView();
        },
        error: function () {
          hideLoader(); 
        },
        async: false
    });
  }

  });
}


if (this.hasAttribute('data-add_product') && !this.hasAttribute('data-check_product_list') && this.hasAttribute('data-add_product_both') == false) {
    const variantId = +$(this).data('add_product');       
    const wantIt = this.dataset.attr === 'yes';        

    $.getJSON(`${root}cart.js`).done(cart => {
      const line = cart.items.find(i => i.variant_id == variantId);

      if (wantIt && !line) {
        $.post(`${root}cart/add.js`, { id: variantId, quantity: 1 })
          .always(updateCartView);
      }

      if (!wantIt && line) {
        $.post(`${root}cart/change.js`, { id: line.key, quantity: 0 })
          .always(updateCartView);
      }

      if ((wantIt && line) || (!wantIt && !line)) updateCartView();
    });
  }

  let allAnswered = true;

  $('input[type="radio"][data-check]').each(function () {
    if (!$(`input[name="${this.name}"]:checked`).length) {
      allAnswered = false;
      return false; 
    }
  });

});



async function getCart() {
  const res = await fetch('/cart.js');
  return await res.json();
}

async function checkForExcludeProducts(cart) {
  let total = 0;
  for (let item of cartItems) {
    const prod = await fetch(`/products/${item.handle}.js`).then(r => r.json());
    if (prod.tags.includes('alarm')) total += item.quantity;
  }
  return total;
}

async function getAlarmQty(cartItems) {
  let total = 0;
  for (let item of cartItems) {
    const prod = await fetch(`/products/${item.handle}.js`).then(r => r.json());
    if (prod.tags.includes('alarm')) total += item.quantity;
  }
  return total;
}

async function syncAlarm() {
  const cart = await getCart();
  const SIGN_UP_VARIANT_ID = Number(document.body.getAttribute('data-sign_up_fee'));
  const SIGN_UP_VARIANT_PRO_ID = Number(document.body.getAttribute('data-sign_up_fee_pro_id'));
  const EXCLUDE_PRODUCTS_ID = document.body.getAttribute('data-sign_up_fee_exclude_products').split(',');

  const nonSignUpItems = cart.items.filter(i => i.product_id !== SIGN_UP_VARIANT_PRO_ID);
  console.log(nonSignUpItems);
  if (nonSignUpItems.length === 1 && nonSignUpItems[0].price === 0) {
    const itemToRemove = nonSignUpItems[0];
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: itemToRemove.key, quantity: 0 })
    });
    if (response.ok) {
      const data = await response.json();
      console.log('Removed zero-price item:', itemToRemove);
      syncAlarm();
    } else {
      console.error('Error removing zero-price item:', response.statusText);
    }
  }
 
  
  const AlarmItems = cart.items.filter(i => i.product_id != SIGN_UP_VARIANT_PRO_ID && !EXCLUDE_PRODUCTS_ID.includes(i.product_id.toString()));
  const AlarmCount = AlarmItems.length;
  
console.log(" nonAlarmCount ", AlarmCount, " EXCLUDE_PRODUCTS_ID ", EXCLUDE_PRODUCTS_ID, " AlarmItems ",AlarmItems); 

  if (AlarmCount === 0) {
    const alarmItem = cart.items.find(i => i.product_id == SIGN_UP_VARIANT_PRO_ID);
    if (alarmItem) {
       const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id: alarmItem.key, quantity: 0 })
      });

      if (response.ok) {
        const data = await response.json();
        updateCartView(); 
      } else {
        console.error('Error updating cart:', response.statusText);
      }
    }
    return;
  }

  const alarmQty = await getAlarmQty(cart.items);
  const alarmItem = cart.items.find(i => i.product_id == SIGN_UP_VARIANT_PRO_ID);
  const currentAlarmQty = alarmItem ? alarmItem.quantity : 0;
  var filteredItems = [];
  // if(cart.item_count == 1)
  // { } 
    filteredItems = cart.items.filter(i => !EXCLUDE_PRODUCTS_ID.includes(i.product_id.toString()));
  if(filteredItems.length > 0)
  {

    if (alarmQty === 0) {
      if (!alarmItem) {     
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: SIGN_UP_VARIANT_ID, quantity: 1 })
        });

        if (response.ok) {
          const data = await response.json();
          updateCartView(); 
        } else {
          console.error('Error updating cart:', response.statusText);
        }
      } else if (currentAlarmQty !== 1) {
        var response = await  fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: alarmItem.key, quantity: 1 })
        });

        if (response.ok) {
          const data = await response.json();
          updateCartView(); 
        } else {
          console.error('Error updating cart:', response.statusText);
        }
      }
    } else {
      if (!alarmItem) {
        console.log(SIGN_UP_VARIANT_ID);  

        var response = await  fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: SIGN_UP_VARIANT_ID, quantity: alarmQty })
        });

        if (response.ok) {
          const data = await response.json();
          updateCartView(); 
        } else {
          console.error('Error updating cart:', response.statusText);
        }
      } else if (currentAlarmQty !== alarmQty) {
        var response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: alarmItem.key, quantity: alarmQty })
        });

        if (response.ok) {
          const data = await response.json();
          updateCartView(); 
        } else {
          console.error('Error updating cart:', response.statusText);
        }
      }
    }
  }
  updateCartView();
}

syncAlarm();
// $(window).on("load",function(){
//   syncAlarm();
// });


const checkoutBtn = document.querySelector('button[name="checkout"]');
if (checkoutBtn) {
  checkoutBtn.addEventListener('click', async function (e) {
    e.preventDefault();
    const el = document.querySelector('[data-vat-related]:checked');
    if (el) {
      el.dispatchEvent(new Event('change', { bubbles: true }));
    }
    await syncAlarm();
    setTimeout(function(){
      window.location.href = '/checkout';
    },500);
  });
  if($('.eq-cart__questions-wrap').length <= 0) {
    checkoutBtn.removeAttribute('disabled');
  }
}


});

